import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FORM_IDS, INTEGRATION_CONSTANTS, QBD_LOADING_STATES, QBD_LOADING_STATES_MESSAGE_MAP } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { componentKey } from "./PlugInSlice";
import { getFormSetting, getLoadImportData, qbPluginDownload } from "./PlugInSaga";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { SOURCE_CONSTANTS } from "../../constants";
import ImportDataGridView from "../../../../components/importdatagridview/ImportDataGridView";
import Button from "../../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../../components/button/constants";
import importSectionStyles from "../../../ImportSection.styles";
import useGarbageCollector from "../../../../../../libs/garbagecollector/garbageCollectorHooks";
import Icons from "../../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../../components/icons/constants";
import Heading from "../../../../../components/heading/Heading";
import qbdStyles from "../Qbd.styles";
import BasicCard from "../../../../../components/card/basiccard/BasicCard";
import Breadcrumbs from "../../../../../components/breadcrumbs/Breadcrumbs";
import { INTEGRATION_ROUTES } from "../../../../constants/constants";
import Loadable from "../../../../../components/loadable/Loadable";

export default function PlugIn() {
    useGarbageCollector(componentKey);
    const [payerId, setPayerId] = useState('');
    const { loadingState, importData, isImportDataGridViewLoaded, formSettings } = useSelector(state => state[componentKey]);
    const [queryParams, setQueryParams] = useSearchParams();
    const dispatch = useDispatch();

    useEffect(() => {
        const { PAYER_ID_PARAM } = INTEGRATION_CONSTANTS;
        if (queryParams.has(PAYER_ID_PARAM)) {
            const payerId = queryParams.get(PAYER_ID_PARAM);
            setPayerId(payerId);
        }
        setQueryParams(queryParams);
    }, [queryParams]);

    useEffect(() => {
        if (payerId !== '') {
            queryParams.forEach((_, key) => {
                queryParams.delete(key);
            });

            setQueryParams(queryParams);
        }
    }, [payerId])


    useEffect(() => {
        if (importData) {
            dispatch(getFormSetting({
                formId: importData?.FormName,
                year: importData?.TaxYear
            }));
        }

    }, [importData]);

    useEffect(() => {
        if (payerId) {
            dispatch(getLoadImportData(
                {
                    integrationImportRequestDto: {
                        PayerId: payerId,
                        Source: SOURCE_CONSTANTS.QBD_PLUGIN_SOURCE
                    }
                }));
        }
    }, [payerId])

    const breadcrumbItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'qbd', link: `/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.QBD}` },
        { text: 'plugin', link: `/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.PLUGIN}` },
    ];

    return (
        <>
            <Breadcrumbs items={breadcrumbItems} />
            {(formSettings && importData && isImportDataGridViewLoaded) ? (

                <ImportDataGridView
                    isStateFilingApplicable={false}
                    filingForCorrected={false}
                    formSettings={formSettings}
                    formName={importData?.FormName}
                    formId={
                        (() => {
                            switch (importData.FormName) {
                                case INTEGRATION_CONSTANTS.NEC_FORM:
                                    return FORM_IDS.$1099NEC;
                                case INTEGRATION_CONSTANTS.MISC_FORM:
                                    return FORM_IDS.$1099MISC;
                                default:
                                    return null;
                            }
                        })()
                    }
                    taxYear={importData?.TaxYear}
                />
            ) : (
                <>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={QBD_LOADING_STATES.PAGE_LOADING}
                        messageMap={QBD_LOADING_STATES_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        <BasicCard>
                            <div>
                                <Heading type="H2">
                                    This plugin will import all qualified 1099 vendors from QuickBooks for Windows to web.tax1099.com
                                </Heading>
                            </div>

                            <div>
                                <Loadable
                                    currentState={loadingState.state}
                                    loadingStates={QBD_LOADING_STATES.FILE_DOWNLOADING}
                                    messageMap={QBD_LOADING_STATES_MESSAGE_MAP}
                                    isNewLoadable={true}
                                >
                                    <Button
                                        type={BUTTON_TYPE.PRIMARY}
                                        onClickCb={() => dispatch(qbPluginDownload())}
                                        style={importSectionStyles.classicButtonStyle}
                                    >
                                        <Icons familyName="vec" iconName={VEC_ICON_NAME.DOWNLOAD_ICON} />
                                        <span style={qbdStyles.labelStyle2}> Download Quickbooks Plugin and user guide</span>
                                    </Button>
                                </Loadable>
                            </div>

                        </BasicCard>
                    </Loadable>
                </>
            )}
        </>
    )
}